import React from 'react';

// Format stored ISO timestamp without performing timezone conversion on the frontend.
// The backend now stores timestamps in IST; this function extracts date and time
// from an ISO string and returns "YYYY-MM-DD, HH:MM:SS IST".
const formatStoredTimestamp = (iso) => {
  if (!iso) return '-';
  try {
    if (typeof iso === 'string') {
      // Expecting ISO like '2025-10-15T18:49:29.804Z' or without Z
      const parts = iso.split('T');
      if (parts.length === 2) {
        const date = parts[0];
        let time = parts[1];
        // remove fractional seconds and trailing timezone marker
        time = time.split('.')[0].replace('Z', '');
        return `${date}, ${time} IST`;
      }
      return iso;
    }
    // Fallback for Date objects: use toISOString and display raw components
    const s = iso.toISOString().split('.')[0].replace('T', ', ');
    return `${s} IST`;
  } catch (e) {
    return iso;
  }
};

export default function StudentTable({ students }) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
      <div className="px-6 py-4 border-b bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-800">Student Roster</h3>
        <p className="text-sm text-gray-500 mt-1">List of students and their latest attendance</p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-white">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Class</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Roll No</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Registration Date</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Last Attendance</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {students.map((s) => {
              const status = s.latestAttendance ? s.latestAttendance.status : 'Absent';
              const rowBg = status === 'Present' ? 'bg-green-50' : status === 'Absent' ? 'bg-red-50' : '';
              // Badge colors: Present -> #6aa84f, Absent -> #f44336 with white text
              const badgeBg = status === 'Present' ? '#6aa84f' : status === 'Absent' ? '#f44336' : '#ffffff';
              const badgeTextColor = status === 'Present' || status === 'Absent' ? '#ffffff' : '#111827';
              return (
                <tr key={s._id} className={`hover:bg-gray-50 ${rowBg}`}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-medium text-gray-900">{s.name}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{s.class || '-'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{s.rollNo ?? '-'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{s.createdAt ? formatStoredTimestamp(s.createdAt) : '-'}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{s.latestAttendance ? (s.latestAttendance.timestamp ? formatStoredTimestamp(s.latestAttendance.timestamp) : formatStoredTimestamp(s.latestAttendance.date)) : '-'}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold" style={{ backgroundColor: badgeBg, color: badgeTextColor }}>{status}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
